import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { ApproveOrderPaymentRequest, SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminOrders } from "@/lib/query/core/invalidation";

type ApproveStoreOrderPaymentInput = {
  storeId: string;
  orderId: string;
} & ApproveOrderPaymentRequest;

export function useApproveStoreOrderPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, orderId, ...body }: ApproveStoreOrderPaymentInput) =>
      apiJsonClient<SellerOrderDetail>(
        endpoints.admin.storeOrderReviewApprove(storeId, orderId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminOrders(queryClient, variables.storeId);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
  };
}
